module.exports = __webpack_public_path__ + "static/media/data-broker-logo-white.cc0919d5.gif";